/// <amd-module name="Widgets/Configs/Common/GenericSelectionDropdown" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { Dropdown } from "VSSUI/Dropdown";
import { IListSelection } from "VSSUI/List";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

export interface GenericSelectionDropdownProps<T> {
    selectedId?: string;
    items: IListBoxItem<T>[];
    onSelect: (newValue: IListBoxItem<T>) => void;
    className?: string;
}

/** This dropdown handles the complexity of standard selection logic. */
export class GenericSelectionDropdown<T> extends VssComponent<GenericSelectionDropdownProps<T>> {
    private selection: IListSelection = new DropdownSelection();

    public componentDidMount(): void {
        this.applySelection(this.props);
    }

    public componentWillReceiveProps(newProps: GenericSelectionDropdownProps<T>): void {
        if (JSON.stringify(newProps) != JSON.stringify(this.props)) {
            this.applySelection(newProps);
        }
    }

    public render(): JSX.Element {
        return (
            <div className="flex-row">
                <Dropdown className={this.props.className} items={this.props.items} selection={this.selection} onSelect={this.onSelect} />
            </div>
        );
    }

    private applySelection(props: GenericSelectionDropdownProps<T>): void {
        // Apply selection from props, and clear any prior selection, if no match is found.
        const selectionPosition = props.items.findIndex(item => {
            return item.id === props.selectedId;
        });
        if (selectionPosition >= 0) {
            this.selection.select(selectionPosition, 1, false);
        } else {
            this.selection.clear();
        }
    }

    private onSelect = (event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<T>): void => {
        this.props.onSelect(item);
    };
}
